import Drawer from '@corvu/drawer'
import { useStore } from '@nanostores/solid'
import { For } from 'solid-js'
import closeXSvg from '~/assets/boosting-sheet/close-x.svg'
import { boostingPacks } from '~/config'
import { m } from '~/paraglide/messages'
import { useBoostingPackPurchase } from '~/resources/use-boosting-pack-purchase'
import {
  $isBoostingPacksOpen,
  closeBoostingPacks,
} from '~/store/boosting-packs'
import { BoostingPackCard } from './boosting-pack-card'

export function BoostingPacksSheet() {
  const open = useStore($isBoostingPacksOpen)
  const purchase = useBoostingPackPurchase()

  return (
    <Drawer
      open={open()}
      onOpenChange={(isOpen) => {
        if (!isOpen) closeBoostingPacks()
      }}
      side="bottom"
      // Don't auto-focus the close button on open — in the webview it shows a
      // lingering "selected" state with no keyboard to clear it.
      onInitialFocus={(e) => e.preventDefault()}
    >
      {(props) => (
        <Drawer.Portal>
          <Drawer.Overlay
            class="fixed inset-0 z-[80] data-[transitioning]:transition-[backdrop-filter,background-color] data-[transitioning]:duration-300 data-[transitioning]:[transition-timing-function:cubic-bezier(0.32,0.72,0,1)]"
            style={{
              'backdrop-filter': `blur(${12.5 * props.openPercentage}px)`,
              '-webkit-backdrop-filter': `blur(${12.5 * props.openPercentage}px)`,
              'background-color': `rgb(0 0 0 / ${0.1 * props.openPercentage})`,
            }}
          />
          <Drawer.Content class="fixed inset-x-0 bottom-0 z-[80] mx-auto flex w-full max-w-[640px] flex-col items-center gap-6 overflow-hidden rounded-t-[36px] border border-white bg-[rgba(255,255,255,0.58)] px-6 pb-12 pt-6 backdrop-blur-lg after:absolute after:inset-x-0 after:top-[calc(100%-1px)] after:h-1/2 after:bg-inherit data-[transitioning]:transition-transform data-[transitioning]:duration-300 data-[transitioning]:[transition-timing-function:cubic-bezier(0.32,0.72,0,1)]">
            {/* Title row — items-center justify-center, px-9 per Figma. */}
            <div class="relative flex w-full items-center justify-center px-9">
              <Drawer.Label class="flex-1 text-center text-[18px] font-semibold leading-[26px] text-[#66402e]">
                {m.booster_sheet_title()}
              </Drawer.Label>
            </div>
            {/* Frosted-glass close button per Figma 4473:36032 — translucent
                white bg + 43.75px backdrop blur + white/30 border. Positioned
                16px from sheet top + right (anchored on Drawer.Content). */}
            <Drawer.Close
              aria-label="Close"
              class="absolute right-4 top-4 z-10 grid size-[42px] shrink-0 place-items-center rounded-[28px] border-[1.75px] border-white/30 bg-white/[0.56] backdrop-blur-[43.75px] focus-visible:outline-none active:scale-95"
            >
              <img src={closeXSvg} alt="" aria-hidden="true" class="size-5" />
            </Drawer.Close>
            {/* Pack list — gap-24 per Figma. */}
            <div class="flex w-full flex-col items-start gap-6">
              <For each={boostingPacks}>
                {(pack) => (
                  <BoostingPackCard
                    pack={pack}
                    pending={
                      purchase.isPending &&
                      purchase.variables?.productId === pack.productId
                    }
                    purchasing={purchase.isPending}
                    onBuy={() => purchase.mutate(pack)}
                  />
                )}
              </For>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      )}
    </Drawer>
  )
}
